import { DropZone } from '@puckeditor/core'
import React from 'react'
import HeadingBlock from './HeadingBlock';
import Card from './Card';


function Column(props) {

    const { zones } = props;
    console.log('zonesss', zones)


    // Component registry mapping component types to their corresponding React components
    const componentRegistry = {
        'HeadingBlock': HeadingBlock,
        'CustomBlock': Card,
        'Column': Column
        // Add other components here as needed
    };

    // Find the keys in zones that end with ":left-column" or ":right-column"
    const leftZoneKey = Object.keys(zones).find(key => key.endsWith('left-column'));
    const rightZoneKey = Object.keys(zones).find(key => key.endsWith('right-column'));

    // console.log('leftZoneKey', leftZoneKey)
    // console.log('rightZoneKey', rightZoneKey)



    const renderLeftColumnDropZone = () => {
        if (leftZoneKey) {
            const leftComponents = zones[leftZoneKey];
            if (Array.isArray(leftComponents) && leftComponents.length > 0) {
                return (
                    <div className="left-column">
                        {leftComponents.map((component, index) => {
                            const Component = componentRegistry[component.type];
                            return <Component key={index} {...component.props} />;
                        })}
                    </div>
                );
            }
        }
        return null;
    };

    const renderRightColumnDropZone = () => {
        if (rightZoneKey) {
            const rightComponents = zones[rightZoneKey];
            if (Array.isArray(rightComponents) && rightComponents.length > 0) {
                return (
                    <div className="right-column">
                        {rightComponents.map((component, index) => {
                            const Component = componentRegistry[component.type];
                            return <Component key={index} {...component.props} />;
                        })}
                    </div>
                );
            }
        }
        return null;
    };



    return (
        <div
            style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}
        >
            <DropZone zone="left-column" />
            <DropZone zone="right-column" />
            {renderLeftColumnDropZone()}
            {renderRightColumnDropZone()}

        </div>
    )
}

export default Column